import { select, call, takeLatest, put } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import Logger from '../../../services/logger.service'
import { ClientDataImportService, IClientDataRequest, IClientDataResponse } from '../services/clientDataImport.service'
import { clientData, ClientDataService, IClientDataDoc } from '../../../services/clientData.service'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { ClientDataConstants } from '../store/clientData.constants'
import { onClientDataImportSuccess, setClientDataError } from '../store/clientData.actions'
import { handleApiError } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import { buildClientDataRequest, ClientDataContentType } from '../../../utilities/clientData.util'

export function* setClientData() {
  const authenticationJwt: string = yield select(getAuthenticationJwtSelector)
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const clientDataImportService = new ClientDataImportService(authenticationJwt as string)
    const clientDataService = new ClientDataService(serviceId)
    const clientDataAll: clientData = yield call([clientDataService, clientDataService.getAllDoc])
    const clientDataReq = buildClientDataRequest(clientDataAll, [ClientDataContentType.PDF])

    const request: IClientDataRequest = {
      clientData: clientDataReq,
    }
    const clientDataRepsonse: IClientDataResponse = yield call(
      [clientDataImportService, clientDataImportService.getClientData],
      request
    )

    if (clientDataRepsonse.status === 200) {
      const { data } = clientDataRepsonse
      if (data && data.length) {
        data.forEach((clientDataDoc: any) => {
          if (clientDataDoc.docData) {
            const clientDataJSON: { entity: any; rules?: any } = JSON.parse(clientDataDoc.docData)
            const clientDataEntity = Object.keys(clientDataJSON).includes('entity')
              ? clientDataJSON.entity
              : clientDataJSON.rules

            const clientData: IClientDataDoc = {
              entity: clientDataEntity || [],
              id: clientDataDoc.id,
              contentType: clientDataDoc.contentType,
              contentDataType: clientDataDoc.contentDataType,
              createDateTime: clientDataDoc.createDateTime,
            }
            clientDataService.createOrUpdateDocument(clientData)
          }
        })
      }
      yield put(setClientDataError(''))
      if (data && !data.length) {
        const isEmpty: boolean = yield call([clientDataService, clientDataService.isEmpty])
        if (isEmpty) {
          yield put(setClientDataError('Client data not does exist, Please contact customer support'))
        }
      }
      yield put(onClientDataImportSuccess())
      Logger.info(`ClientData: setClientData success, data length: ${data.length}`)
    } else {
      clientDataRepsonse.failure = true
      if (clientDataRepsonse.messages?.length) {
        const index = clientDataRepsonse.messages.findIndex((x) => x.status === clientDataRepsonse.status)
        clientDataRepsonse.responseMessage = clientDataRepsonse.messages[index]?.message
      } else {
        clientDataRepsonse.responseMessage =
          'There was an error retrieving client data. Please contact customer support for further assistance.'
      }
      yield put(handleApiError(clientDataRepsonse))
    }
  } catch (e: any) {
    let cause = ''
    if (e.messages && e.messages.length) {
      const index = e.messages.findIndex((x: any) => x.status === e.status)
      cause = e.messages[index].message
      yield put(handleApiError(e))
    }
    yield put(setClientDataError(cause || e.toString()))
    Logger.error(`Error retrieving client data', ${e}`)
  }
}

export function* setClientDataSaga() {
  yield takeLatest([ClientDataConstants.SET_CLIENT_DATA], setClientData)
}
